import { useAtom, useSetAtom } from 'jotai';
import { Comment_AddComment_RequestBody, CommentAPIs } from '~/common/typescript/apis/CommentAPIs';
import { currentProjectAtom } from '~/stores/ProjectStore';
import { commentsAtom, newlyCreatedCommentIdAtom } from '../../Comment/CommentStore';
import { CommentMapUtilOptimized } from '../../Comment/CommentMapUtilOptimized';
import maplibregl from 'maplibre-gl';

export const useAddCommentAtCoordinates = () => {
  const [currentProject] = useAtom(currentProjectAtom);
  const [comments, setComments] = useAtom(commentsAtom);
  const setNewlyCreatedCommentId = useSetAtom(newlyCreatedCommentIdAtom);

  const addCommentAtCoordinates = async (lng: number, lat: number) => {
    if (!currentProject?.id) {
      console.error('No current project selected');
      return;
    }

    try {
      const payload: Comment_AddComment_RequestBody = {
        projectId: currentProject.id,
        title: "Chưa điền tiêu đề",
        description: "Chưa điền mô tả",
        geojson: JSON.stringify({
          type: "point",
          coordinates: [lng, lat]
        })
      };

      const result = await CommentAPIs.remote_addComment(payload);

      if (result.data) {
        // Update comments list
        setComments([...comments, result.data]);

        // Mark this comment as newly created to trigger auto-edit mode
        setNewlyCreatedCommentId(result.data.id!);

        return result.data;
      }
    } catch (error) {
      console.error('Failed to add comment:', error);
    }
  };

  return { addCommentAtCoordinates };
};